import classNames from "classnames";
import { observer } from "mobx-react";
import React from "react";
import {
  AutoCompleteProps,
  AutoComplete
} from "@fidget/common/components/form/autoComplete/autoComplete";
import { intl } from "@fidget/common/i18n/TypedIntl";

import { useStore } from "../../../models";
import settingsStyles from "../../../styles/settings.css";
import { presenceStatusLabel } from "../../status/Status";
import { AppPresence } from "@closerplatform/spinner-openapi";

interface Props extends Omit<Partial<AutoCompleteProps<AppPresence>>, "onChange"> {
  onChange(value: AppPresence): void;
  value?: AppPresence;
}
export const StatusPicker = observer(
  ({ value, onChange, className, ...autoCompleteProps }: Props) => {
    const { currentUserStore } = useStore();
    const areCallsDisabled = !!currentUserStore.orgConfig?.callsDisabled;
    const statuses = Object.values(AppPresence).filter(
      (status) => status !== AppPresence.Away || !areCallsDisabled
    );

    const handleChange = (val: AppPresence | "") => {
      if (val) {
        onChange(val);
      }
    };

    return (
      <AutoComplete<AppPresence>
        {...autoCompleteProps}
        className={classNames(settingsStyles["input-max-width-bigger"], className)}
        onChange={handleChange}
        itemsProvider={() => statuses}
        itemToString={(val) => (val && presenceStatusLabel(val, areCallsDisabled)) || ""}
        placeholder={intl.formatMessage("statusPicker.placeholder")}
        inputValue={value}
        readOnly
      />
    );
  }
);
